import { DatePicker } from "@mui/x-date-pickers"
import PeriodNavigationButton from "components/common/PeriodNavigationButton"
import { Flex } from "components/common/StyledComponents"
import { DateTime } from "luxon"

type Props = {
  endDate: DateTime
  onChange: (patch: { endDate?: DateTime; startDate?: DateTime }) => void
  onShiftPeriod: (delta: number) => void
  startDate: DateTime
}

const DateRangeFilterControls = ({ endDate, onChange, onShiftPeriod, startDate }: Props) => {
  return (
    <Flex alignItems="center" className="flex-wrap" gap={1}>
      <PeriodNavigationButton direction="previous" onClick={() => onShiftPeriod(-1)} />
      <DatePicker
        format="dd/MM/yyyy"
        label="Từ ngày"
        onChange={(value) => {
          if (value) onChange({ startDate: value })
        }}
        slotProps={{ textField: { size: "small" } }}
        value={startDate}
      />
      <DatePicker
        format="dd/MM/yyyy"
        label="Đến ngày"
        onChange={(value) => {
          if (value) onChange({ endDate: value })
        }}
        slotProps={{ textField: { size: "small" } }}
        value={endDate}
      />
      <PeriodNavigationButton direction="next" onClick={() => onShiftPeriod(1)} />
    </Flex>
  )
}

export default DateRangeFilterControls
